class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // console.log('din cart open!!')
    autoOpenFreeProductModal();

    // Okendo re-initialises every widget on the page here, far too slow to run before the drawer's first frame (INP)
    requestAnimationFrame(() => setTimeout(() => window.okeWidgetApi?.initAllWidgets()));
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, isFromBundleBuilder, productsIdList) {
    // console.log('@---------> productsIdList', productsIdList)

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (window.innerWidth < 991 && document.querySelector('.atc-notification-modal') && !(window.location.href.includes('cart'))) {
      console.log('@-> open mobile modal add to cart notification')

      let shouldOpenCart = false;

      // if (productsIdList.length > 1) {
      //   console.log('multiple added products', parsedState.items)

      //   //get data and update modal
      //   let itemsContainer = document.querySelector('.atc-notification-modal__items');

      //   itemsContainer.innerHTML = ``;

      //   parsedState.items.forEach(item => {
      //     itemsContainer.innerHTML += `
      //     <div class="atc-notification-modal__item-wrapper">
      //       <div class="item-image"><img src="${item.featured_image.url}" alt=""></div>
      //       <div class="item-main-details">
      //         <p class="item-title">${item.title}</p>
      //         <p class="item-price">C$${(item.final_price / 100).toFixed(2)}</p>
      //         <p class="item-old-price"></p>
      //       </div>
      //       <div class="item-extra-details">
      //         <p>Eau de Parfum. Size: 50ml / 1.7oz</p>
      //         <p>
      //           ${window.Shopify.locale == 'fr' ? item.vendor.replace('Inspired by', 'Inspiré de') : item.vendor}
      //         </p>
      //       </div>
      //     </div>
      //     `
      //   })
      // }
      // else if (productsIdList.length != 0) {
      //   console.log('single added product')
      //   let itemsContainer = document.querySelector('.atc-notification-modal__items');

      //   //get data and update modal
      //   let currentProduct;
      //   if (document.querySelector('.cart-free-product_container') && document.querySelector(`.cart-free-product_container .cart-item[data-product-id="${productsIdList[0]}"]`)) {

      //     console.log('@--> avem free product 222');

      //     shouldOpenCart = true;

      //     currentProduct = {
      //       id: productsIdList[0],
      //       img_src: document.querySelector(`.cart-free-product_container .cart-item[data-product-id='${productsIdList[0]}'] .cart-item__image`)?.src,
      //       title: document.querySelector(`.cart-free-product_container .cart-item[data-product-id='${productsIdList[0]}'] .cart-item__name`)?.textContent,
      //       price: document.querySelector(`.cart-free-product_container .cart-item[data-product-id='${productsIdList[0]}'] .cart-item__price-wrapper span`)?.textContent,
      //       inspired_by: document.querySelector(`.cart-free-product_container .cart-item[data-product-id='${productsIdList[0]}']  .cart-item__details > p.caption-with-letter-spacing`)?.textContent,
      //     }
      //   }
      //   else {
      //     currentProduct = {
      //       id: productsIdList[0],
      //       img_src: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__image`)?.src,
      //       title: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__name`)?.textContent,
      //       price: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__new-price`) ? document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__new-price`)?.textContent : document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .price`)?.textContent,
      //       ogPrice: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__old-price`)?.textContent,
      //       inspired_by: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"]  .cart-item__details-extra > p:last-child`)?.textContent,
      //     }
      //   }


      //   console.log('curent product!', currentProduct)

      //   itemsContainer.innerHTML = ``;

      //   if (currentProduct.ogPrice != undefined) {

      //     itemsContainer.innerHTML = `
      //      <div class="atc-notification-modal__item-wrapper">
      //         <div class="item-image"><img src="${currentProduct.img_src}" alt=""></div>
      //         <div class="item-main-details">
      //           <p class="item-title">${currentProduct.title}</p>
      //           <div class="atc-price-wrapper">
      //             <p class="item-price">${currentProduct.price}</p>
      //             <p class="item-old-price">${currentProduct.ogPrice}</p>
      //           </div>
      //         </div>
      //         <div class="item-extra-details">
      //           <p>Eau de Parfum. Size: 50ml / 1.7oz</p>
      //           <p>
      //             ${currentProduct.inspired_by}
      //           </p>
      //         </div>
      //       </div>
      //     `;
      //   }
      //   else {
      //     itemsContainer.innerHTML = `
      //      <div class="atc-notification-modal__item-wrapper">
      //         <div class="item-image"><img src="${currentProduct.img_src}" alt=""></div>
      //         <div class="item-main-details">
      //           <p class="item-title">${currentProduct.title}</p>
      //           <p class="item-price">${currentProduct.price}</p>
      //         </div>
      //         <div class="item-extra-details">
      //           <p>Eau de Parfum. Size: 50ml / 1.7oz</p>
      //           <p>
      //             ${currentProduct.inspired_by}
      //           </p>
      //         </div>
      //       </div>
      //     `;
      //   }

      // }

      // //qty calc

      // let qty = document.querySelector('[data-cart-qty]').dataset.cartQty;
      // let pills = document.querySelectorAll('.atc-notification-modal__progress-bar-wrapper .progress-bar-v2 .pill')

      // pills.forEach((pill, index) => {
      //   if (index < qty) {
      //     pill.classList.add('active')
      //   }
      //   else {
      //     pill.classList.remove('active')
      //   }
      // })

      //open modal
      if (!isFromBundleBuilder) {

        if (document.querySelector('.drawer:not(.active)')) {

          console.log('if eligible show atc first')
          if (!document.querySelector(".cart-free-product_container--main_product .cart-item") && document.querySelector("body.crmOfferON") && document.querySelector('[data-cart-qty]').dataset.cartQty >= 2) {
            console.log('show free product modal!!')
            document.querySelector('#free-product-modal-gift').classList.toggle('show');
          }
          else {
            document.querySelector('.atc-notification-modal').show();

            document.body.classList.add('overflow-hidden');
            document.querySelector('.atc-notification-modal').classList.remove('animate-slideToBottomPopup');
            document.querySelector('.atc-notification-modal').classList.add('animate-slideFromBottomPopup');


            //close after 4 seconds
            setTimeout(() => {
              document.querySelector('.atc-notification-modal').classList.remove('animate-slideFromBottomPopup');
              document.querySelector('.atc-notification-modal').classList.add('animate-slideToBottomPopup');
              document.body.classList.remove('overflow-hidden');
            }, 3500)
            setTimeout(() => {
              document.querySelector('.atc-notification-modal:has(.small-version)').close();
            }, 4000);
          }

        }
      }
      else {
        bundleBuilderInit();
      }

    }
    else {

      if (isFromBundleBuilder || document.querySelector('.bundle-builder')) {
        console.log('added item from bundle builder')
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          // this.open();
        });
      }
      else if (window.location.href.includes('cart')) {
        // console.log("product added din cart page")
        // console.log(document.querySelector('cart-items'))
        if (!document.querySelector('cart-items')) {
          window.location.reload();
        }
      }
      else {
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          this.open();
        });
      }
    }

    showDynamicPrices();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {

    if (window.location.href.includes('/cart')) {
      // if on cart page return both cart page and card drawer sections to render
      // this help cart page and cart drawer to sync the renreders
      return [
        {
          id: 'main-cart-items',
          section: document.querySelector('.cart__wrapper #main-cart-items').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
        {
          id: 'main-cart_order-summary', //html element id to rerender
          section: document.getElementById('main-cart-items').dataset.id, //represents shopify section id
          selector: '.cart-subtotal', // represents actual css selector for the section to rerender
        },
        {
          id: 'cart__progress-bar', //html element id to rerender
          section: document.getElementById('main-cart-items').dataset.id, //represents shopify section id
          selector: '.master-conteiner_for_progress-bar', // represents actual css selector for the section to rerender
        },
        {
          id: 'cart__bottom-checkout-btn', //html element id to rerender
          section: document.getElementById('main-cart-items').dataset.id, //represents shopify section id
          selector: '.cart__checkout-button', // represents actual css selector for the section to rerender
        },
        {
          id: 'cart_checkout-btn', //html element id to rerender
          section: document.getElementById('main-cart-items').dataset.id, //represents shopify section id
          selector: '.cart__checkout-button', // represents actual css selector for the section to rerender
        },
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }

    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
